import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./location.component.scss']
})
export class LocationComponent {

}
